export function TargetLowIncomeIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="cash">
      <path id="Vector" d="M2.66667 22.6667V9.33333C2.66667 7.86057 3.86058 6.66667 5.33334 6.66667H13.3333H18.6667H26.6667C28.1394 6.66667 29.3333 7.86057 29.3333 9.33333V22.6667C29.3333 24.1394 28.1394 25.3333 26.6667 25.3333H18.6667H13.3333H5.33333C3.86057 25.3333 2.66667 24.1394 2.66667 22.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_2" d="M16 20C13.7909 20 12 18.2091 12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 18.2091 18.2091 20 16 20Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_3" d="M24.6667 16.0133L24.68 15.9985" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_4" d="M7.33333 16.0133L7.34667 15.9985" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
